import React from "react";
import { EditorCopyBar } from "./EditorCopyBar";
import { useAdminPriceEdaContext } from "./context";
import { EditorConfirmBar } from "./EditorConfirmBar";
import { EditorHotkeys } from "./EditorHotkeys";
import { EditorModeSwitch } from "./EditorModeSwitch";
import { EditorPopup } from "./EditorPopup";
import { EditorSelectionSummary } from "./EditorSelectionSummary";
import { EditorTariffSwitch } from "./EditorTariffSwitch";
import cls from "./styles.module.scss";

export const EditorSidebar = () => {
  const {
    editor: { popupOpen },
  } = useAdminPriceEdaContext();

  return (
    <aside className={cls.sidebar}>
      <EditorHotkeys />
      <div className={cls.divider} />
      <EditorCopyBar />
      <div className={cls.divider} />
      <EditorTariffSwitch />
      <div className={cls.divider} />
      <EditorModeSwitch />
      <div className={cls.divider} />
      <EditorPopup />
      {popupOpen && <div className={cls.divider} />}
      <EditorSelectionSummary />
      <div className={cls.divider} />
      <EditorConfirmBar />
    </aside>
  );
};
